/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Br_History_Key_Thermostatdefect1Inputs */



/**
* | output |
* | --- |
* | "Safety thermostat defect" |
*
* @param {Br_History_Key_Thermostatdefect1Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const br_history_key_thermostatdefect1 = /** @type {((inputs?: Br_History_Key_Thermostatdefect1Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Br_History_Key_Thermostatdefect1Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Safety thermostat defect")
	return /** @type {LocalizedString} */ ("Défaut thermostat de sécurité")
});
export { br_history_key_thermostatdefect1 as "br_history_key_thermostatDefect" }